import PageHero from '@/components/PageHero'
import SEOHead from '@/components/SEOHead'

function Privacy() {
  return (
    <div>
      <SEOHead
        title="Privacy Policy"
        description="Read the AdsROAS Calculator privacy policy covering data collection, cookies, and how we handle information on our free advertising calculators."
      />

      <PageHero
        eyebrow="Legal"
        title="Privacy Policy"
        description="Last updated: January 2025. How AdsROAS Calculator handles information on our free advertising tools."
        compact
      />

      <section className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8 py-12 sm:py-14">
        <div className="bg-white border border-slate-200 rounded-2xl p-6 sm:p-8 space-y-8 text-slate-600 leading-relaxed shadow-[0_1px_2px_rgba(15,23,42,0.04)]">
          <div>
            <h2 className="text-lg font-extrabold text-slate-900 tracking-tight mb-2">1. Overview</h2>
            <p>
              AdsROAS Calculator ("we", "us", "our") operates www.adsroascalculator.com (the "Service").
              This Privacy Policy explains what information is collected when you use our free advertising
              calculators and how that information is used.
            </p>
          </div>

          <div>
            <h2 className="text-lg font-extrabold text-slate-900 tracking-tight mb-2">2. Information We Collect</h2>
            <p>
              Our calculators run entirely in your browser. Numbers you enter into any calculator (ad spend,
              revenue, conversion rates, etc.) are processed locally on your device and are not transmitted to
              or stored on our servers. If you submit the Contact form, we collect the name, email address,
              subject, and message you provide solely to respond to your inquiry.
            </p>
          </div>

          <div>
            <h2 className="text-lg font-extrabold text-slate-900 tracking-tight mb-2">3. Cookies & Analytics</h2>
            <p>
              We may use minimal, privacy-conscious analytics to understand aggregate usage patterns (such as
              which calculators are most popular) in order to improve the Service. These analytics do not
              identify you personally and are not used for advertising or resold to third parties.
            </p>
          </div>

          <div>
            <h2 className="text-lg font-extrabold text-slate-900 tracking-tight mb-2">4. Third-Party Links</h2>
            <p>
              Our Service may contain links to third-party websites, including advertising platforms such as
              Google Ads, Meta Ads, and Amazon Advertising. We are not responsible for the privacy practices of
              these third-party sites and encourage you to review their respective privacy policies.
            </p>
          </div>

          <div>
            <h2 className="text-lg font-extrabold text-slate-900 tracking-tight mb-2">5. Data Security</h2>
            <p>
              Because calculator inputs are processed client-side and are not persisted to a database, there is
              no server-side storage of your calculation data. Contact form submissions are handled with
              reasonable administrative and technical safeguards.
            </p>
          </div>

          <div>
            <h2 className="text-lg font-extrabold text-slate-900 tracking-tight mb-2">6. Children's Privacy</h2>
            <p>
              Our Service is not directed to individuals under the age of 16, and we do not knowingly collect
              personal information from children.
            </p>
          </div>

          <div>
            <h2 className="text-lg font-extrabold text-slate-900 tracking-tight mb-2">7. Changes to This Policy</h2>
            <p>
              We may update this Privacy Policy from time to time. Any changes will be reflected on this page
              with an updated "Last updated" date.
            </p>
          </div>

          <div>
            <h2 className="text-lg font-extrabold text-slate-900 tracking-tight mb-2">8. Contact Us</h2>
            <p>
              If you have questions about this Privacy Policy, please reach out via our{' '}
              <span className="font-medium text-slate-900">Contact</span> page.
            </p>
          </div>
        </div>
      </section>
    </div>
  )
}

export default Privacy
